const NS = 'OverviewBlock';
const CLS = 'overviewBlock';
const BLK = '.' + CLS + '-';

export class OverviewBlock {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$slider = this.$el.find(`.${CLS}-slider`);
		this.$sliderItem = this.$el.find(`.${CLS}-slider-container`);

		this.autoplaySpeed = this.$el.data('autoplay-speed') || 3000;
		this.autoplayOption = this.$el.data('autoplay') || false;
	}

	init() {
		const slickOptions = {
			fade: true,
			arrows: false,
			autoplay: this.autoplayOption,
			autoplaySpeed: this.autoplaySpeed,
			dots: true,
			dotsClass: `${CLS}-slider-dots`,
		};
		this.$slider.slick(slickOptions);
		this.$sliderItem.parent().addClass(`${CLS}-slider-item-parent`);

		$(document).on('click', `.${CLS} .dropdown-menu`, function(e) {
			if (e.target.id === $('#overviewCloseDropdown').attr('id')) {
				return false;
			}

			e.stopPropagation();
		});

		$('#overviewCloseDropdown').on('click', () => {
			$('.overviewBlock-cardContent-btn').trigger('click');
		});
	}
}
